import { useEffect, useState } from 'react';
import {
  MenuItem,
  Stack,
  TextField,
} from '@mui/material';

const CUSTOM_ACTION = '__custom__';

export const FOLLOW_UP_ACTION_OPTIONS = [
  'Contactar con cliente',
  'Revisar actividad o consumo',
  'Revisar precio',
  'Revisar condiciones comerciales',
  'Preparar propuesta comercial',
  'Solicitar o contrastar información',
  'Comprobar próxima compra',
] as const;

type Props = {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  optional?: boolean;
};

function resolveMode(value: string): string {
  if (!value) {
    return '';
  }

  return FOLLOW_UP_ACTION_OPTIONS.includes(
    value as (typeof FOLLOW_UP_ACTION_OPTIONS)[number],
  )
    ? value
    : CUSTOM_ACTION;
}

export default function FollowUpActionSelector({
  value,
  onChange,
  disabled = false,
  optional = true,
}: Props) {
  const [mode, setMode] = useState(
    resolveMode(value),
  );

  useEffect(() => {
    setMode(resolveMode(value));
  }, [value]);

  return (
    <Stack spacing={1}>
      <TextField
        select
        size="small"
        label="Siguiente acción"
        value={mode}
        disabled={disabled}
        onChange={(event) => {
          const nextMode = event.target.value;
          setMode(nextMode);

          if (nextMode === CUSTOM_ACTION) {
            onChange('');
            return;
          }

          onChange(nextMode);
        }}
        helperText={
          optional
            ? 'Selecciona una acción habitual o escribe una distinta.'
            : 'Selecciona una acción o utiliza la opción manual.'
        }
      >
        {optional && (
          <MenuItem value="">
            Sin acción definida
          </MenuItem>
        )}

        {FOLLOW_UP_ACTION_OPTIONS.map(
          (option) => (
            <MenuItem
              key={option}
              value={option}
            >
              {option}
            </MenuItem>
          ),
        )}

        <MenuItem value={CUSTOM_ACTION}>
          Otra acción…
        </MenuItem>
      </TextField>

      {mode === CUSTOM_ACTION && (
        <TextField
          size="small"
          label="Acción manual"
          value={value}
          disabled={disabled}
          inputProps={{ maxLength: 1000 }}
          multiline
          minRows={2}
          onChange={(event) =>
            onChange(event.target.value)}
          helperText="Describe la acción concreta. Máximo 1000 caracteres."
        />
      )}
    </Stack>
  );
}
